window.EmberENV={ ...(window.EmberENV || {}), ...{
  "EXTEND_PROTOTYPES": false,
  "FEATURES": {},
  "_APPLICATION_TEMPLATE_WRAPPER": false,
  "_DEFAULT_ASYNC_OBSERVERS": true,
  "_JQUERY_INTEGRATION": false,
  "_NO_IMPLICIT_ROUTE_MODEL": true,
  "_TEMPLATE_ONLY_GLIMMER_COMPONENTS": true,
  "_USE_EMBER_MODULES": true
} };var runningTests=false;